// @flow
import React from "react";
import Types from "../actions/Types";
import Actions from "../actions/Creators";
import fileDownload from "js-file-download";
import { put, call, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

export default (api: Object) => {
  /* Get invoices */
  function* getInvoices(action) {
    try {
      const response = yield call(api.statements.getInvoices, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getInvoicesSuccess(response.data));
      } else {
        yield put(Actions.getInvoicesFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getInvoicesFailure(error));
    }
  }
  function* watchGetInvoices(): Generator<void, void, void> {
    yield takeLatest(Types.GET_INVOICES, getInvoices);
  }

  /* Get invoices */
  function* getInvoicesNoon(action) {
    try {
      const response = yield call(api.statements.getInvoicesNoon, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getInvoicesNoonSuccess(response.data));
      } else {
        yield put(Actions.getInvoicesNoonFailure(response.error || "Error"));
        toast(response.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getInvoicesNoonFailure(error));
    }
  }
  function* watchGetInvoicesNoon(): Generator<void, void, void> {
    yield takeLatest(Types.GET_INVOICES_NOON, getInvoicesNoon);
  }

  /* Get PAYMENTS */
  function* getPayments(action) {
    try {
      const response = yield call(api.statements.getPayments, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getPaymentsSuccess(response.data));
      } else {
        yield put(Actions.getPaymentsFailure(response.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getPaymentsFailure(error));
    }
  }
  function* watchGetPayments(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PAYMENTS, getPayments);
  }

  /* Get Credit Notes */
  function* getCreditNotes(action) {
    try {
      const response = yield call(api.statements.getCreditNotes, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getCreditNotesSuccess(response.data));
      } else {
        yield put(
          Actions.getCreditNotesFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getCreditNotesFailure(error));
    }
  }
  function* watchGetCreditNotes(): Generator<void, void, void> {
    yield takeLatest(Types.GET_CREDIT_NOTES, getCreditNotes);
  }
  /* Get PAYMENT DETAILS */
  function* getPaymentDetails(action) {
    try {
      const response = yield call(
        api.statements.getPaymentDetails,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getPaymentDetailsSuccess(response.data));
      } else {
        yield put(Actions.getPaymentDetailsFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getPaymentsFailure(error));
    }
  }
  function* watchGetPaymentDetails(): Generator<void, void, void> {
    yield takeLatest(Types.GET_PAYMENT_DETAILS, getPaymentDetails);
  }

  /* Get finance */
  function* getFinanceView(action) {
    try {
      const response = yield call(api.statements.getFinanceView, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getFinanceViewSuccess(response.data));
      } else {
        yield put(
          Actions.getFinanceViewFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getFinanceViewFailure(error));
    }
  }
  function* watchGetFinanceView(): Generator<void, void, void> {
    yield takeLatest(Types.GET_FINANCE_VIEW, getFinanceView);
  }

  /* Get order view */
  function* getOrderView(action) {
    try {
      const response = yield call(api.statements.getOrderView, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.getOrderViewSuccess(response.data));
      } else {
        yield put(Actions.getOrderViewFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.getOrderViewFailure(error));
    }
  }
  function* watchGetOrderView(): Generator<void, void, void> {
    yield takeLatest(Types.GET_ORDER_VIEW, getOrderView);
  }

  /* Export Invoice */
  function* exportInvoice(action) {
    try {
      const response = yield call(api.statements.exportInvoice, action.query);

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.exportInvoiceSuccess(response.data));
        fileDownload(response.data, "invoice.csv");
      } else {
        yield put(Actions.exportInvoiceFailure(response.data.error || "Error"));
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportInvoiceFailure(error));
    }
  }
  function* watchExportInvoice(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_INVOICE, exportInvoice);
  }

  /* Export CreditNote */
  function* exportCreditNote(action) {
    try {
      const response = yield call(
        api.statements.exportCreditNote,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.exportCreditNoteSuccess(response.data));
        fileDownload(response.data, "credit-note.csv");
      } else {
        yield put(
          Actions.exportCreditNoteFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportCreditNoteFailure(error));
    }
  }
  function* watchExportCreditNote(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_CREDIT_NOTE, exportCreditNote);
  }

  /* Export Invoice */
  function* exportStatements(action) {
    try {
      const response = yield call(
        api.statements.exportStatements,
        action.query
      );

      if (
        response.ok &&
        response.data &&
        {}.hasOwnProperty.call(response, "data")
      ) {
        yield put(Actions.exportStatementsSuccess(response.data));
        fileDownload(response.data, "statements.csv");
      } else {
        yield put(
          Actions.exportStatementsFailure(response.data.error || "Error")
        );
        toast(response.data.error || "Error", {
          type: "error",
          className: "errorClass"
        });
      }
    } catch (error) {
      yield put(Actions.exportStatementsFailure(error));
    }
  }
  function* watchExportStatements(): Generator<void, void, void> {
    yield takeLatest(Types.EXPORT_STATEMENTS, exportStatements);
  }

  return {
    watchGetInvoices,
    watchGetInvoicesNoon,
    watchGetCreditNotes,
    watchGetPayments,
    watchGetFinanceView,
    watchGetOrderView,
    watchExportCreditNote,
    watchExportInvoice,
    watchExportStatements,
    watchGetPaymentDetails
  };
};



// WEBPACK FOOTER //
// ./src/sagas/StatementsSaga.js